export default [
    {
        path: '/list/disclaimer/main',
        name: 'list/disclaimer/main',
        component: () => import(/* webpackChunkName: "list" */ '../views/list/disclaimer/main')
    },
    {
        path: '/list/message_list/list',
        name: 'list/message_list/list',
        component: () => import(/* webpackChunkName: "list" */ '../views/list/message_list/list')
    },
    {
        path: '/list/learn_layout/main',
        name: 'list/learn_layout/main',
        component: () => import(/* webpackChunkName: "list" */ '../views/list/learn_layout/main')
    },
    {
        path: '/list/qa',
        name: 'list/qa',
        component: () => import(/* webpackChunkName: "list" */ '../views/list/qa/index')
    },
    {
        path: '/list/qa-mini',
        name: 'list/qa-mini',
        component: () => import(/* webpackChunkName: "list" */ '../views/list/qa/mini')
    }
]